export enum CampaignTriggers {
  TRANSACTION = "transaction",
  INTERNAL_EVENT = "internal_event",
  CUSTOM_EVENT = "custom_event",
  CUSTOM_EVENT_UNIQUE_CODE = "custom_event_unique_code",
  ACHIEVEMENT = "achievement",
  TIME = "time",
  RETURN_TRANSACTION = "return_transaction",
  LEADERBOARD = "leaderboard",
}

export type CampaignTriggersUnion = `${CampaignTriggers}`;

export interface CampaignTrigger {
  campaign: CampaignTriggersUnion;
  label: string;
  descriptionText?: string;
  tooltip?: JSX.Element;
}

export enum TriggerStrategyType {
  DAILY = "daily",
  WEEKLY = "weekly",
  BIRTHDAY = "birthday",
  MONTHLY = "monthly",
  REGISTRATION_ANNIVERSARY = "registration_anniversary",
}

export type TriggerStrategyTypeUnion = `${TriggerStrategyType}`;

export type TriggerStrategy = {
  type: TriggerStrategyTypeUnion;
  executionSchedule?: {
    dayOfWeek?: number[];
    dayOfMonth?: number[] | "L"[];
  };
};
